import React from 'react';
import PageTitle from '../../FormElements/PageTitle';
import GlobalErrorsBox from '../../ErrorComponents/GlobalErrorBox/GlobalErrorsBox';
import FormSection from '../../FormElements/FormSection';
import FormSubmit from '../../FormElements/FormSubmit';
import Label from '../../FormElements/Label';
import TextInput from '../../FormElements/TextInput';
import DropdownList from '../../FormElements/DropdownList';
import EmailInput from '../../FormElements/EmailInput';
import SecondaryButton from '../../Buttons/SecondaryButton';

export default class OwnershipForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			id: null,
			property_id: null,
			ownership_type: '',
			entity_name: '',
			entity_federal_tax_id: '',
			entity_registration_date: '',
			entity_federally_taxed: '',
			owner_1_first_name: '',
			owner_1_last_name: '',
			owner_1_ssn_itin: '',
			owner_1_phone_number: '',
			owner_1_email: '',
			hasSecondOwner: false,
			owner_2_first_name: '',
			owner_2_last_name: '',
			owner_2_ssn_itin: '',
			owner_2_phone_number: '',
			owner_2_email: '',
			errorsList: [],
			fieldErrors: {}
		};

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.loadData = this.loadData.bind(this);
		this.onAddSecondOwner = this.onAddSecondOwner.bind(this);
	}

	componentDidMount() {
		this.loadData();
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: 'smooth'
		});
	}

	renderOwnershipType() {
		const ownershipTypeValue = this.state.ownership_type || '';
		return (
			<DropdownList
				label="Ownership Type"
				displayLabel={true}
				onChange={this.onChange}
				id="ownership_type"
				name="ownership_type"
				value={ownershipTypeValue}
				data={[
					{ id: 0, name: '' },
					{ id: 1, name: 'Sole Proprietorship' },
					{ id: 2, name: 'Single-Member LLC' },
					{ id: 3, name: 'LLC' },
					{ id: 4, name: 'Corporation' },
					{ id: 5, name: 'S Corporation' },
					{ id: 6, name: 'Limited Partnership' },
					{ id: 7, name: 'General Partnership' }
				]}
			/>
		);
	}

	renderFirstOwnerDetailsSection() {
		return (
			<div>
				<Label htmlFor="owner_1_first_name">Owner's First Name *</Label>
				<TextInput
					id="owner_1_first_name"
					name="owner_1_first_name"
					value={this.state.owner_1_first_name}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<Label htmlFor="owner_1_last_name">Owner's Last Name *</Label>
				<TextInput
					id="owner_1_last_name"
					name="owner_1_last_name"
					value={this.state.owner_1_last_name}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<Label htmlFor="owner_1_ssn_itin">Owner's SSN / ITIN *</Label>
				<TextInput
					id="owner_1_ssn_itin"
					name="owner_1_ssn_itin"
					value={this.state.owner_1_ssn_itin}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<Label htmlFor="owner_1_phone_number">Owner's Phone Number *</Label>
				<TextInput
					id="owner_1_phone_number"
					name="owner_1_phone_number"
					value={this.state.owner_1_phone_number}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<Label htmlFor="owner_1_email">Owner's Email *</Label>
				<EmailInput
					id="owner_1_email"
					name="owner_1_email"
					value={this.state.owner_1_email}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>
				{this.state.hasSecondOwner &&
					this.state.ownership_type !== 'Sole Proprietorship' &&
					this.renderSecondOwnerDetailsSection()}
			</div>
		);
	}

	renderSecondOwnerDetailsSection() {
		if (this.state.hasSecondOwner) {
			return (
				<div>
					<Label htmlFor="owner_2_first_name">
						Second Owner's First Name *
					</Label>
					<TextInput
						id="owner_2_first_name"
						name="owner_2_first_name"
						value={this.state.owner_2_first_name}
						onChange={this.onChange}
					/>

					<Label htmlFor="owner_2_last_name">Second Owner's Last Name *</Label>
					<TextInput
						id="owner_2_last_name"
						name="owner_2_last_name"
						value={this.state.owner_2_last_name}
						onChange={this.onChange}
					/>

					<Label htmlFor="owner_2_ssn_itin">Second Owner's SSN / ITIN</Label>
					<TextInput
						id="owner_2_ssn_itin"
						name="owner_2_ssn_itin"
						value={this.state.owner_2_ssn_itin}
						onChange={this.onChange}
					/>

					<Label htmlFor="owner_2_phone_number">
						Second Owner's Phone Number *
					</Label>
					<TextInput
						id="owner_2_phone_number"
						name="owner_2_phone_number"
						value={this.state.owner_2_phone_number}
						onChange={this.onChange}
					/>

					<Label htmlFor="owner_2_email">Second Owner's Email *</Label>
					<EmailInput
						id="owner_2_email"
						name="owner_2_email"
						value={this.state.owner_2_email}
						onChange={this.onChange}
					/>
				</div>
			);
		} else {
			return null;
		}
	}

	renderEntityDetailsSection() {
		return (
			<div>
				<Label htmlFor="entity_name">Entity Name *</Label>
				<TextInput
					id="entity_name"
					name="entity_name"
					value={this.state.entity_name}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<Label htmlFor="entity_federal_tax_id">Entity Federal Tax ID *</Label>
				<TextInput
					id="entity_federal_tax_id"
					name="entity_federal_tax_id"
					value={this.state.entity_federal_tax_id}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<Label htmlFor="entity_registration_date">
					Entity Registration Date *
				</Label>
				<TextInput
					id="entity_registration_date"
					name="entity_registration_date"
					value={this.state.entity_registration_date}
					onChange={this.onChange}
					fieldErrors={this.state.fieldErrors}
				/>

				<DropdownList
					label="Is this Entity Federally Taxed?"
					displayLabel={true}
					onChange={this.onChange}
					id="entity_federally_taxed"
					name="entity_federally_taxed"
					value={this.state.entity_federally_taxed}
					data={[
						{ id: 0, name: '' },
						{ id: 1, name: 'Yes' },
						{ id: 2, name: 'No' }
					]}
					fieldErrors={this.state.fieldErrors}
				/>
			</div>
		);
	}

	renderOwnerDetailsSectionConditional() {
		return (
			<div>
				{this.state.ownership_type === '' ? null : (
					<React.Fragment>
						{this.state.ownership_type !== 'Sole Proprietorship' &&
							this.renderEntityDetailsSection()}
						{this.renderFirstOwnerDetailsSection()}
					</React.Fragment>
				)}
			</div>
		);
	}

	renderButtonsSection() {
		return (
			<div>
				{this.state.ownership_type === '' ? null : (
					<div className="grid grid-cols-1 lg:grid-cols-2">
						{this.state.ownership_type === 'Sole Proprietorship' ||
						this.state.ownership_type === 'Single-Member LLC' ? (
							<div
								className={
									'lg:justify-self-start hidden lg:contents lg:invisible'
								}
							>
								<SecondaryButton
									onClick={this.onAddSecondOwner}
									label="Add a second owner"
								/>
							</div>
						) : this.state.ownership_type !== 'Sole Proprietorship' ||
						this.state.ownership_type !== 'Single-Member LLC' ? (
							<div
								className={
									'lg:justify-self-start' +
									(this.state.hasSecondOwner
										? ' hidden lg:contents lg:invisible'
										: ' ')
								}
							>
								<SecondaryButton
									onClick={this.onAddSecondOwner}
									label="Add a second owner"
								/>
							</div>
						) : null}
						<div className="lg:justify-self-end">
							<FormSubmit
								onSubmit={this.onSubmit}
								label={
									this.props.isEditing ? (
										'Save changes'
									) : (
										'Add ownership details'
									)
								}
							/>
						</div>
					</div>
				)}
			</div>
		);
	}

	render() {
		// console.log('OwnershipForm', this.props, this.state);
		return (
			<div className="OwnershipForm w-full py-4">
				<PageTitle
					title={
						this.props.isEditing ? (
							'Update your ownership details'
						) : (
							'Add your ownership details'
						)
					}
				/>
				<GlobalErrorsBox globalErrors={this.state.errorsList} />
				<FormSection>
					{this.renderOwnershipType()}
					{this.renderOwnerDetailsSectionConditional()}
				</FormSection>
				{this.renderButtonsSection()}
			</div>
		);
	}

	onAddSecondOwner() {
		this.setState({ hasSecondOwner: true });
	}

	onChange(e) {
		const { name, value } = e.target;

		// Reset hasSecondOwner to false when ownership_type changes
		if (name === 'ownership_type' && value !== 'Sole Proprietorship') {
			this.setState({ hasSecondOwner: false });
		}

		// Update state
		this.setState({ [name]: value });
	}

	onSubmit(e) {
		// console.log('Create ownership call stated...');
		e.preventDefault();
		e.stopPropagation();

		$.ajax({
			type: 'POST',
			url: true
				? this.props.update_property_ownership_endpoint.replace(
						'id',
						this.state.id
					)
				: this.props.create_property_ownership_endpoint,
			dataType: 'json',
			data: {
				property_ownership: {
					property_id: this.state.property_id,
					ownership_type: this.state.ownership_type,
					entity_name: this.state.entity_name,
					entity_federal_tax_id: this.state.entity_federal_tax_id,
					entity_registration_date: this.state.entity_registration_date,
					entity_federally_taxed:
						this.state.entity_federally_taxed === 'Yes' ? true : false,
					owner_1_first_name: this.state.owner_1_first_name,
					owner_1_last_name: this.state.owner_1_last_name,
					owner_1_ssn_itin: this.state.owner_1_ssn_itin,
					owner_1_phone_number: this.state.owner_1_phone_number,
					owner_1_email: this.state.owner_1_email,
					owner_2_first_name: this.state.owner_2_first_name,
					owner_2_last_name: this.state.owner_2_last_name,
					owner_2_ssn_itin: this.state.owner_2_ssn_itin,
					owner_2_phone_number: this.state.owner_2_phone_number,
					owner_2_email: this.state.owner_2_email
				}
			},
			error: (response) => {
				// console.log('Create/update ownership call failed.', response.responseJSON);
				this.setState({
					// errorsList: response.responseJSON.errors, // Enable for errors list
					fieldErrors: response.responseJSON.field_errors // Enable for field errors
				});
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			}
		}).done((response, status) => {
			// console.log('Create ownership call successful.', response, status);
			window.location.href = `/properties/${this.props.propertyId}`;
		});
	}

	loadData() {
		$.ajax({
			type: 'GET',
			url: this.props.get_property_ownership_by_property_endpoint.replace(
				'property_id',
				this.props.propertyId
			)
		}).done((payload) => {
			const result = payload;
			// console.log('Ownership loadData done', result);
			this.setState({
				id: result.data[0].id,
				property_id: result.data[0].property_id,
				ownership_type: result.data[0].ownership_type,
				entity_name: result.data[0].entity_name,
				entity_federal_tax_id: result.data[0].entity_federal_tax_id,
				entity_registration_date: result.data[0].entity_registration_date,
				entity_federally_taxed: result.data[0].entity_federally_taxed
					? 'Yes'
					: 'No',
				owner_1_first_name: result.data[0].owner_1_first_name,
				owner_1_last_name: result.data[0].owner_1_last_name,
				owner_1_ssn_itin: result.data[0].owner_1_ssn_itin,
				owner_1_phone_number: result.data[0].owner_1_phone_number,
				owner_1_email: result.data[0].owner_1_email,
				hasSecondOwner:
					result.data[0].owner_2_first_name && result.data[0].owner_2_last_name
						? true
						: false,
				owner_2_first_name: result.data[0].owner_2_first_name,
				owner_2_last_name: result.data[0].owner_2_last_name,
				owner_2_ssn_itin: result.data[0].owner_2_ssn_itin,
				owner_2_phone_number: result.data[0].owner_2_phone_number,
				owner_2_email: result.data[0].owner_2_email
			});
		});
	}
}
